'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'child-combatant';
var width = 512;
var height = 512;
var aliases = ["child-rifle"];
var unicode = 'e4e0';
var svgPathData = 'M112 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 80 64 64 64 0 1 0 208 64zM138.3 192l11.3 0c9.5 0 18.6 2.8 26.3 7.9l0 152.1-64 0 0-152.1c7.7-5.1 16.8-7.9 26.3-7.9zM112 496l0-112 64 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-252.7 42.4 69.1c4.6 7.5 14.5 9.9 22 5.3s9.9-14.5 5.3-22l-59.8-97.5c-14.5-23.7-40.4-38.2-68.2-38.2l-11.3 0c-27.8 0-53.7 14.5-68.2 38.2L10.4 295.6c-4.6 7.5-2.3 17.4 5.3 22s17.4 2.3 22-5.3L80 243.3 80 496c0 8.8 7.2 16 16 16s16-7.2 16-16zM384 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 96c-17.7 0-32 14.3-32 32l0 32c-26.5 0-48 21.5-48 48l0 112c0 26.5 21.5 48 48 48l0 80c0 17.7 14.3 32 32 32l66.2 0c21.6 0 37-20.9 30.5-41.5l-27-86.5 42.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-35.5 51.9-13c7.1-1.8 12.1-8.2 12.1-15.5l0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 67.5-32 8 0-123.5c0-17.7-14.3-32-32-32l0-112c0-8.8-7.2-16-16-16L384 0zm0 160l32 0 0 208c0 1.6 .2 3.2 .7 4.8l33.5 107.2-66.2 0 0-96c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16-7.2-16-16l0-112c0-8.8 7.2-16 16-16l16 0c8.8 0 16-7.2 16-16l0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChildCombatant = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;